export class ScrollHelper {
    /**
     * Scrolls both the mat-sidenav-content container and the window to the top position.
     * This ensures the page starts at the top regardless of which element contains the scrollable content.
     */
    static scrollToTopOfPage(): void {
        const container = document.querySelector('mat-sidenav-content');
        if (container) {
            container.scrollTo({ top: 0, behavior: 'smooth' });
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
